var BasicSetting = {
    create: function () {
        var setting = {};
        //环境切换
        // var environment = process.env.VUE_APP_ENVIRONMENT; // dev prod stage
        var environment = 'produce'; // dev prod stage

        var BasicSetting = {
            dev: "http://192.168.2.165:8889",
            stage: "http://duoledemo.fznet.top",
            // produce: "https://duole.fznet.top",

            produce: "https://orthonowadmin.doradent.cn",
        }
        var apiUrl = BasicSetting.produce;

        if (environment == 'dev') {
            apiUrl = BasicSetting.dev;
        } else if (environment == 'stage') {
            apiUrl = BasicSetting.stage;
        } else if (environment == 'prod') {
            apiUrl = BasicSetting.produce;
        }

        setting.init = function () {
        };
        setting.getApiUrl = function () {
            return apiUrl;
        }
        setting.getUploadUrl = function () {
            // return imgUrl;
        }
        return setting;
    }
}

module.exports.BasicSetting = BasicSetting;
